import { H5_PLAY_EVENT, COMMON_DATA_KEY, STATS_NAME, H5_EXT_EVENT, Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { __extends, __assign, __awaiter, __generator } from 'tslib';
import { TPColorPrimaries, TPTransferCharacteristics, getEventTargetBinder, uaTool, urlTool, getEventEmitterBinder, PLAY_EVENT } from '@tencent/thumbplayer-core';
import { txpHideClass } from '@tencent/thumbplayer-plugin-utils';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".txp_console{color:#fff;font-family:PingFangSC-Regular,Helvetica Neue,Helvetica,Roboto,Microsoft Yahei,Arial,sans-serif;font-size:10px;font-weight:400;height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:10}.txp_console .txp_none,.txp_console.txp_none{display:none!important}.txp_console .txp_console_header .txp_info_panel_btn{background-color:#444;border:none;border-radius:2px;color:#fff;cursor:pointer;font-size:10px;margin:2px;outline:none;padding:2px 4px;-webkit-transition:all .5s;transition:all .5s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.txp_console .txp_console_header .txp_info_panel_btn:hover{-webkit-filter:contrast(1.5) brightness(.8);filter:contrast(1.5) brightness(.8)}.txp_console .txp_console_header .txp_info_panel_btn:active{-webkit-filter:unset;filter:unset}.txp_console .txp_console_header .txp_btn_close{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;border:none;color:#fff;cursor:pointer;font-family:inherit;font-size:1em;outline:0 none;position:relative}.txp_console .txp_console_inner{background-color:rgba(28,28,28,.8);border-radius:4px;margin:10px 0 0 10px;padding:8px 5px;pointer-events:auto;position:absolute;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.txp_console .txp_console_inner .txp_line_container{margin-top:8px;overflow-x:hidden;overflow-y:auto}.txp_console .txp_console_inner .txp_console_header{-webkit-box-pack:end;-ms-flex-pack:end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;justify-content:flex-end;padding:0 8px;width:100%}.txp_console .txp_console_inner .txp_console_header .txp_console_header_title{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-size:12px;font-weight:900}.txp_console .txp_console_inner .txp_console_header .txp_log_upload{-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;justify-content:center;margin-right:4px}.txp_console .txp_console_inner .txp_console_header .txp_log_upload.info_panel_uploading:before{display:block}.txp_console .txp_console_inner .txp_console_header .txp_log_upload:before{background-image:url(data:image/svg+xml;base64,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);content:\"\";display:none;height:10px;width:10px}.txp_console .txp_console_inner .txp_console_header .txp_log_upload.txp_none{display:none}.txp_console .txp_console_inner .txp_line{display:-webkit-box;display:-ms-flexbox;display:flex;line-height:1.6}.txp_console .txp_console_inner .txp_line .txp_compact_label,.txp_console .txp_console_inner .txp_line .txp_label{-ms-flex-negative:0;display:inline-block;flex-shrink:0;padding-right:6px;text-align:right;width:9em}.txp_console .txp_console_inner .txp_line .txp_compact_label:after,.txp_console .txp_console_inner .txp_line .txp_label:after{content:\":\"}.txp_console .txp_console_inner .txp_line .txp_compact_label{display:none}.txp_console .txp_console_inner .txp_line .txp_value{display:inline-block;text-align:left;vertical-align:text-top;width:30em;word-break:break-all}.txp_console.fullscreen .txp_console_inner{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%;margin:0;overflow:hidden;width:100%}.txp_console.fullscreen .txp_console_inner .txp_line{display:none}.txp_console.fullscreen .txp_console_inner .txp_line.line-compact{display:-webkit-box;display:-ms-flexbox;display:flex}.txp_console.fullscreen .txp_console_inner .txp_line.line-compact .txp_compact_label,.txp_console.fullscreen .txp_console_inner .txp_line.line-compact .txp_label{display:none;width:4em}.txp_console.fullscreen .txp_console_inner .txp_line.line-compact .txp_compact_label{display:block}.txp_info_icon{fill:#fff;border-radius:5px;cursor:pointer;height:24px;opacity:.5;position:absolute;right:8px;top:8px;-webkit-transition:all .3s;transition:all .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:24px;z-index:4}.txp_info_icon:hover{opacity:1}.txp_info_icon.small{height:16px;width:16px}.txp_info_icon.txp_none{display:none!important}";
styleInject(css_248z);

var _a, _b;
/**
 * 暂停时展示在右上角的信息面板入口 ICON
 */
var INFO_SVG_DOM_STR = /* html */ "<div class=\"txp_info_icon txp_none\">\n  <svg\n  viewBox=\"0 0 1024 1024\"\n  version=\"1.1\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n  >\n  <path\n    d=\"M512 958.016C266.08 958.016 65.984 757.952 65.984 512 65.984 266.08 266.08 65.984 512 65.984c245.952 0 446.016 200.064 446.016 446.016C958.016 757.952 757.952 958.016 512 958.016zM512 129.984C301.344 129.984 129.984 301.344 129.984 512c0 210.624 171.36 382.016 382.016 382.016 210.624 0 382.016-171.36 382.016-382.016C894.016 301.344 722.624 129.984 512 129.984z\"\n  ></path>\n  <path\n    d=\"M512 304m-48 0a1.5 1.5 0 1 0 96 0 1.5 1.5 0 1 0-96 0Z\"\n  ></path>\n  <path\n    d=\"M512 768c-17.664 0-32-14.304-32-32l0-288c0-17.664 14.336-32 32-32s32 14.336 32 32l0 288C544 753.696 529.664 768 512 768z\"\n  ></path>\n  </svg>\n</div>\n";
// eslint-disable-next-line @typescript-eslint/naming-convention
var InfoPanelPluginName = 'info-panel';
var InfoPanelEvents = {
    CLICK_UPLOAD: 'contextmenu:click-upload',
};
var DEFAULT_SHOW_QUERY = 'show_info_panel';
// 弹出的 Tips 浮层的 z-index 值
var REPORT_TIPS_Z_INDEX = 101;
// 信息面板提供诶离线日志的上报来源字段
var OFFLINE_LOG_REPORT_TAG = 'info-panel:click';
// debug模式信息面板参数名
var DEBUG_MODE_PANEL_ITEM_NAME = {
    resolution: 'debug:resolution',
    framerate: 'debug:framerate',
    scanMode: 'debug:scanMode',
    colorGamut: 'debug:colorGamut',
    colorTransfer: 'debug:colorTransfer',
    pixelFormat: 'debug:pixelFormat',
    bitDepth: 'debug:bitDepth',
    samplingStructure: 'debug:samplingStructure',
    pixelShape: 'debug:pixelShape',
    pixelDirection: 'debug:pixelDirection',
};
var DEBUG_COLOR_PRIMARIES_PRESENTATION_STRING = (_a = {},
    _a[TPColorPrimaries.BT709] = 'ITU-R BT.709',
    _a[TPColorPrimaries.BT2020] = 'ITU-R BT.2020',
    _a[TPColorPrimaries.BT601] = 'ITU-R BT.601',
    _a[TPColorPrimaries.BT2100] = 'ITU-R BT.2100',
    _a);
var DEBUG_TRANSFER_CHARACTERISTICS_PRESENTATION_STRING = (_b = {},
    _b[TPTransferCharacteristics.SRGB] = 'ITU-R BT.709',
    _b[TPTransferCharacteristics.BT709] = 'ITU-R BT.709',
    _b[TPTransferCharacteristics.GAMMA22] = 'Gamma 2.2',
    _b[TPTransferCharacteristics.GAMMA28] = 'Gamma 2.8',
    _b[TPTransferCharacteristics.BT601] = 'ITU-R BT.601',
    _b[TPTransferCharacteristics.BT2020] = 'ITU-R BT.2020',
    _b[TPTransferCharacteristics.BT2100HLG] = 'HLG',
    _b[TPTransferCharacteristics.BT2100PQ] = 'PQ',
    _b);

/**
 * 长按呼出信息面板逻辑
 */
var TouchLogics = /** @class */ (function () {
    function TouchLogics(player, options) {
        var _this = this;
        this.player = player;
        this.options = options;
        /** 去除掉浏览器默认的右键菜单 */
        this.onContextMenu = function (event) {
            event.preventDefault();
        };
        /**
         * 触摸操作开始，设置回调定时器，触摸时长超过阈值，则触发回调
         */
        this.onTouchStart = function (event) {
            var touches = event.touches;
            // 如果是多指触控，会重复进入 onTouchStart
            // 此时重置定时器，兼容缩放等多指手势操作
            if (touches.length > 1) {
                _this.reset();
                return;
            }
            var _a = touches[0], clientX = _a.clientX, clientY = _a.clientY, target = _a.target;
            // 只有触摸的是控制栏的渐变层或 h5player 自带的交互层，才进行后续操作
            if (!_this.isValidEl(target)) {
                return;
            }
            // 设置下起点
            _this.touchBaseX = clientX;
            _this.touchBaseY = clientY;
            // 设置超时阈值
            clearTimeout(_this.triggerTimer);
            _this.triggerTimer = setTimeout(_this.options.callback, _this.options.timeout);
        };
        /**
         * 触摸操作结束而时长未达阈值，取消回调定时器
         */
        this.onTouchEnd = function () {
            _this.reset();
        };
        /**
         * 监听手指滑动，滑动幅度很大时
         * 取消掉信息面板展示定时器
         */
        this.onTouchMove = function (event) {
            var touches = event.touches;
            // 如果是多指触控，不做处理
            if (!_this.triggerTimer || touches.length !== 1) {
                return;
            }
            // 计算下移动偏移值，防止手指细小抖动导致无法触发回调
            var _a = touches[0], clientX = _a.clientX, clientY = _a.clientY;
            var maximumMoveDistance = Math.max(Math.abs(clientX - _this.touchBaseX), Math.abs(clientY - _this.touchBaseY));
            // 如果偏移值超出阈值，说明不是因为用户手抖造成的
            // 而是有意为之（比如 m 站直接右滑播放器来拖进度条）
            // 取消掉回调定时器
            if (maximumMoveDistance > MAX_MOVE_THRESHOLD) {
                _this.reset();
            }
        };
        this.setContainerStyle(true);
        this.bindEvents(true);
    }
    TouchLogics.prototype.destroy = function () {
        this.setContainerStyle(false);
        this.bindEvents(false);
    };
    TouchLogics.prototype.setContainerStyle = function (isApply) {
        if (isApply === void 0) { isApply = true; }
        var container = this.player.container;
        if (isApply) {
            // 去除 iOS 下，默认选中 & 菜单行为
            container.style.setProperty('-webkit-user-select', 'none');
            container.style.setProperty('-webkit-touch-callout', 'none');
            return;
        }
        container.style.removeProperty('-webkit-user-select');
        container.style.removeProperty('-webkit-touch-callout');
    };
    TouchLogics.prototype.bindEvents = function (isBind) {
        if (isBind === void 0) { isBind = true; }
        var binder = getEventTargetBinder(this.player.container, isBind);
        binder('touchstart', this.onTouchStart, { passive: true });
        binder('touchend', this.onTouchEnd, { passive: true });
        binder('touchmove', this.onTouchMove, { passive: true });
        binder('contextmenu', this.onContextMenu);
    };
    TouchLogics.prototype.reset = function () {
        this.touchBaseX = null;
        this.touchBaseY = null;
        clearTimeout(this.triggerTimer);
        this.triggerTimer = null;
    };
    TouchLogics.prototype.isValidEl = function (el) {
        var _a, _b, _c;
        var ctrlShowEl = (_c = (_b = (_a = this.player.plugins.ctrlbar) === null || _a === void 0 ? void 0 : _a.instances) === null || _b === void 0 ? void 0 : _b.CtrlShow) === null || _c === void 0 ? void 0 : _c.shadow;
        var h5InteractMod = this.player.interactMod;
        return el === ctrlShowEl || el === h5InteractMod;
    };
    return TouchLogics;
}());
// 长按时，手指在 xy 轴上能够移动的最大位移量（像素）
// 这个值不能太大，小心列文虎克小拖进度条导致误触发
var MAX_MOVE_THRESHOLD = 3;

function copyToClipBoard(message) {
    if (canUseClipboardAPI()) {
        return copyAsync(message);
    }
    return copySynchronized(message);
}
/**
 * 复制到剪贴板的兼容方法，缺点是 execCommand 是同步的
 */
function copySynchronized(message) {
    var input = document.createElement('input');
    input.setAttribute('style', 'position: absolute; clip: rect(0 0 0 0); opacity: 0;');
    input.value = message;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy', true);
    input.remove();
}
function copyAsync(message) {
    return navigator.clipboard.writeText(message);
}
function canUseClipboardAPI() {
    var _a;
    return typeof ((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) === 'function'
        // 移动端的 x5 和 QQ 浏览器使用 writeText 接口总是无权限，直接降级回老API
        && !uaTool.browser.x5
        && !uaTool.browser.mqqbrowser;
}

function getHtml(list) {
    return /* html */ "<div class=\"txp_console txp_none\" style=\"z-index: 100\">\n    <div class=\"txp_console_inner\">\n      <div class=\"txp_console_header\">\n      <span class=\"txp_console_header_title\">\u64AD\u653E\u4FE1\u606F</span>\n      <span class=\"txp_info_panel_btn txp_log_upload\">\n        \u4E0A\u4F20\u65E5\u5FD7\n      </span>\n      <button class=\"txp_info_panel_btn txp_log_download\">\n        \u8C03\u8BD5\u4FE1\u606F\n      </button>\n      <button class=\"txp_btn_close\" title=\"\u5173\u95ED\">[X]</button>\n      </div>\n    <div class=\"txp_line_container\">\n      ".concat(list.map(function (item) {
        var key = item.key, _a = item.title, title = _a === void 0 ? '' : _a, _b = item.style, style = _b === void 0 ? '' : _b, label = item.label, value = item.value, compactLabel = item.compactLabel;
        return /* html */ "<div class=\"txp_line ".concat(compactLabel ? 'line-compact' : '', "\" data-key=\"").concat(key, "\" title=\"").concat(title || '', "\" style=\"").concat(style || '', "\">\n            <div class=\"txp_label\">").concat(label, "</div>\n            ").concat(compactLabel ? /* html */ "<div class=\"txp_compact_label\">".concat(compactLabel, "</div>") : '', "\n            <div class=\"txp_value\">").concat(value, "</div>\n          </div>");
    }).join(''), "\n    </div>\n    </div>\n  </div>");
}
var InfoPanelPlugin = /** @class */ (function (_super) {
    __extends(InfoPanelPlugin, _super);
    function InfoPanelPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        /** @deprecated */
        _this.inited = true;
        _this.itemDomMap = {};
        _this.isShowing = false;
        _this.isReporting = false;
        /** 存储信息面板展示的信息，方便复制按钮读取 */
        _this.curInfoMap = {};
        _this.autoplayBlockedType = '';
        _this.stateQueue = [];
        _this.disabled = false;
        _this.seekHistoryNum = 3;
        _this.seekHistoryList = [];
        _this.onKeyDown = function (evt) {
            var metaKey = evt.metaKey, ctrlKey = evt.ctrlKey, code = evt.code, shiftKey = evt.shiftKey;
            // 组合键，
            if (code === 'KeyI' && ((metaKey && uaTool.os.mac)
                || (ctrlKey && !uaTool.os.mac))) {
                _this.toggle();
            }
            // 快捷键 cmd/ctrl + shift + u 触发日志上报
            if (code === 'KeyU'
                && ((metaKey && uaTool.os.mac) || (ctrlKey && !uaTool.os.mac))
                && shiftKey) {
                _this.triggerLogReport();
            }
        };
        _this.onDebugInfoChange = function () {
            var _a = _this, isShowing = _a.isShowing, config = _a.config;
            // 如果没有展示信息面板，不做任何取数逻辑，减少开销
            if (!isShowing) {
                return;
            }
            if (!config.enableDebugMode) {
                // 没有开启debug模式，只获取常规的播放信息
                _this.collectRegularPlaybackStats();
                return;
            }
            // 开启debug模式，获取视频流相关的信息
            _this.collectDetailedMediaInfo();
        };
        _this.onVideoSeek = function (e) {
            var type = e.type;
            var time = parseFloat(_this.player.playtime.toFixed(3));
            if (type === H5_PLAY_EVENT.VIDEO_SEEKING) {
                var seekInfo = _this.seekHistoryList.length < _this.seekHistoryNum
                    ? { start: -1, end: -1 } : _this.seekHistoryList.shift();
                seekInfo.start = time;
                seekInfo.end = -1;
                _this.seekHistoryList.push(seekInfo);
            }
            else if (type === H5_PLAY_EVENT.VIDEO_SEEKED) {
                if (_this.seekHistoryList.length) {
                    _this.seekHistoryList[_this.seekHistoryList.length - 1].end = time;
                }
            }
            _this.onDebugInfoChange();
        };
        _this.onSessionEnd = function () {
            _this.seekHistoryList = [];
            _this.onDebugInfoChange();
        };
        _this.onVideoAutoPlayBlock = function () {
            _this.autoplayBlockedType = 'vb';
        };
        _this.onAdAutoPlayBlock = function () {
            _this.autoplayBlockedType = 'ab';
        };
        _this.onStatsChange = function (e) {
            _this.infoItems.forEach(function (infoItem) {
                // e.data给过来的是一个数据，包含所有已经变化的key
                var updateInfo = e.data.find(function (info) { return info.key === infoItem.key; });
                if (updateInfo) {
                    _this.setItemTextByKey(updateInfo.key, updateInfo.value, infoItem.hideItemIfEmpty);
                }
            });
        };
        _this.onPlayerStatsChange = function () {
            var state = _this.player.state;
            var stateStr = state.charAt(0) + state.charAt(state.length - 1);
            _this.stateQueue.push(stateStr);
            _this.stateQueue = _this.stateQueue.slice(-5);
            _this.onDebugInfoChange();
        };
        _this.onDatasetUpdate = function (e) {
            var keys = [
                COMMON_DATA_KEY.sessionRetryBackUrlCount,
                COMMON_DATA_KEY.sessionRetryPlayCount,
                COMMON_DATA_KEY.sessionBufferCount,
                COMMON_DATA_KEY.drm,
            ];
            if (keys.indexOf(e.data.key) !== -1) {
                _this.onDebugInfoChange();
            }
        };
        var _a = _this.player.config.infoPanelConfig, infoPanelConfig = _a === void 0 ? { defaultInfo: false, disableDefaultKey: [] } : _a;
        _this.config = __assign(__assign({}, infoPanelConfig), config);
        if (!STATS_NAME) {
            // bugfix: 在播放器没有锁定插件版本之前，旧播放器可能会更新到最新的插件。而这个`STATS_NAME`就是新插件的代码，旧播放器并没有这个枚举
            // 所以这里暂时先return掉了。
            _this.disabled = true;
            return _this;
        }
        _this.initTouchLogics();
        _this.renderInfoIcon();
        _this.createInfoItems();
        _this.renderInfoItems();
        _this.bindInfoItemEvts(true);
        _this.addUIEvts();
        _this.bindHotKeyEvts(true);
        return _this;
    }
    /** @deprecated */
    InfoPanelPlugin.prototype.start = function () { };
    /** 获取面板上的DOM元素 */
    InfoPanelPlugin.prototype.getItemDom = function (key) {
        if (!this.elInner) {
            return null;
        }
        return this.itemDomMap[key];
    };
    /** 显示信息面板 */
    InfoPanelPlugin.prototype.show = function () {
        if (this.disabled)
            return;
        this.updateInfoItems();
        // 展示信息面板时，结合播放器大小设置下信息面板 class
        if (this.isMiniPanel()) {
            this.elInner.classList.add('fullscreen');
        }
        else {
            this.elInner.classList.remove('fullscreen');
        }
        this.isShowing = true;
        this.elInner.classList.remove('txp_none');
    };
    /** 隐藏信息面板 */
    InfoPanelPlugin.prototype.hide = function () {
        if (this.disabled)
            return;
        this.isShowing = false;
        this.elInner.classList.add('txp_none');
    };
    InfoPanelPlugin.prototype.toggle = function () {
        if (this.isShowing) {
            return this.hide();
        }
        this.show();
    };
    InfoPanelPlugin.prototype.showIcon = function () {
        if (this.disabled)
            return;
        if (this.isMiniPanel()) {
            this.infoIcon.classList.add('small');
        }
        else {
            this.infoIcon.classList.remove('small');
        }
        this.infoIcon.classList.remove('txp_none');
    };
    InfoPanelPlugin.prototype.hideIcon = function () {
        if (this.disabled)
            return;
        this.infoIcon.classList.add('txp_none');
    };
    InfoPanelPlugin.prototype.trigger = function () {
        if (this.isShowing) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    Object.defineProperty(InfoPanelPlugin.prototype, "showing", {
        get: function () {
            return this.isShowing;
        },
        enumerable: false,
        configurable: true
    });
    InfoPanelPlugin.prototype.destroy = function () {
        var _a, _b, _c;
        (_a = this.touchLogics) === null || _a === void 0 ? void 0 : _a.destroy();
        this.bindInfoItemEvts(false);
        this.bindHotKeyEvts(false);
        (_b = this.elInner) === null || _b === void 0 ? void 0 : _b.remove();
        (_c = this.infoIcon) === null || _c === void 0 ? void 0 : _c.remove();
        this.itemDomMap = null;
        this.elInner = null;
        this.infoItems = null;
        this.seekHistoryList = null;
        this.curInfoMap = null;
        _super.prototype.destroy.call(this);
    };
    InfoPanelPlugin.prototype.initTouchLogics = function () {
        var _a = this.config, _b = _a.showInfoPanelByPress, showInfoPanelByPress = _b === void 0 ? true : _b, _c = _a.showByPressTimeout, showByPressTimeout = _c === void 0 ? 2000 : _c;
        // 非 x5 的移动端模式下，添加长按播放器呼出信息面板的逻辑
        if (showInfoPanelByPress && uaTool.mobile && !uaTool.browser.x5) {
            this.touchLogics = new TouchLogics(this.player, {
                callback: this.show.bind(this),
                timeout: showByPressTimeout,
            });
        }
    };
    /**
     * 开播时，检查下 url Query，在特定 query 下展示信息面板
     */
    InfoPanelPlugin.prototype.hookPlaySessionStart = function () {
        var _a = this.config.showOnQuery, showOnQuery = _a === void 0 ? DEFAULT_SHOW_QUERY : _a;
        if (urlTool.getUrlParamByKey(location.href, showOnQuery)) {
            this.show();
        }
    };
    /**
     * 在视频暂停时，展示右上角 ICON
     */
    InfoPanelPlugin.prototype.hookVideoPause = function () {
        var _a = this.config.showInfoIconOnPause, showInfoIconOnPause = _a === void 0 ? true : _a;
        if (showInfoIconOnPause) {
            this.showIcon();
        }
    };
    InfoPanelPlugin.prototype.hookVideoPlaying = function () {
        var _a = this.config.showInfoIconOnPause, showInfoIconOnPause = _a === void 0 ? true : _a;
        if (showInfoIconOnPause) {
            this.hideIcon();
        }
    };
    InfoPanelPlugin.prototype.renderInfoIcon = function () {
        var _this = this;
        var container = this.player.container;
        container.insertAdjacentHTML('beforeend', INFO_SVG_DOM_STR);
        this.infoIcon = container.querySelector('.txp_info_icon');
        this.infoIcon.addEventListener('click', function () {
            _this.toggle();
        });
    };
    /**
     * 渲染列表项
     */
    InfoPanelPlugin.prototype.renderInfoItems = function () {
        var _this = this;
        var _a;
        var _b = this.config.showUploadBtn, showUploadBtn = _b === void 0 ? uaTool.mobile : _b;
        var listToAppend = this.infoItems;
        var container = this.player.container;
        var htmlStr = getHtml(listToAppend);
        container.insertAdjacentHTML('beforeend', htmlStr);
        this.elInner = container.querySelector('.txp_console');
        this.closeBtn = this.elInner.querySelector('.txp_btn_close');
        this.uploadBtn = this.elInner.querySelector('.txp_info_panel_btn.txp_log_upload');
        this.downloadBtn = this.elInner.querySelector('.txp_info_panel_btn.txp_log_download');
        // 如果离线日志插件不存在，则不展示上报按钮 & 下载日志按钮
        if (!this.player.offlineLog) {
            this.uploadBtn.classList.add(txpHideClass);
            this.downloadBtn.classList.add(txpHideClass);
        }
        // 只展示一个按钮，上传日志 或 下载日志到本地
        if (!showUploadBtn && ((_a = this.player.offlineLog) === null || _a === void 0 ? void 0 : _a.downloadLogs)) {
            this.uploadBtn.classList.add(txpHideClass);
        }
        else {
            this.downloadBtn.classList.add(txpHideClass);
        }
        listToAppend.forEach(function (i) {
            var item = { el: null, value: null };
            item.el = _this.elInner.querySelector("[data-key=\"".concat(i.key, "\"]"));
            item.value = item.el.querySelector('.txp_value');
            _this.itemDomMap[i.key] = item;
        });
    };
    /**
     * 设置日志上传按钮状态
     * @param isUploading 是否在上传中
     */
    InfoPanelPlugin.prototype.setUploadBtnState = function (isUploading) {
        this.uploadBtn.textContent = isUploading ? '上传中...' : '上传日志';
        this.uploadBtn.classList.toggle('info_panel_uploading');
        this.uploadBtn.dataset.reporting = String(isUploading);
        this.isReporting = isUploading;
    };
    InfoPanelPlugin.prototype.addUIEvts = function () {
        var _this = this;
        this.closeBtn.addEventListener('click', function () { return _this.hide(); });
        this.uploadBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            _this.copyToClipboard();
            _this.triggerLogReport();
        });
        this.downloadBtn.addEventListener('click', function () {
            var _a, _b;
            _this.copyToClipboard();
            // 一些旧版本有可能没有 downloadLogs，额外 ?. 判空
            (_b = (_a = _this.player.offlineLog) === null || _a === void 0 ? void 0 : _a.downloadLogs) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    /**
     * 复制信息面板数据到剪贴板
     */
    InfoPanelPlugin.prototype.copyToClipboard = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, copyToClipBoard(JSON.stringify(this.curInfoMap))];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    InfoPanelPlugin.prototype.triggerLogReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var zIndex, err_1;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // 如果正在上报，或者说根本没有离线日志模块，则什么也不做
                        if (this.isReporting || !((_a = this.player.offlineLog) === null || _a === void 0 ? void 0 : _a.reportLogs))
                            return [2 /*return*/];
                        zIndex = REPORT_TIPS_Z_INDEX;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        this.setUploadBtnState(true);
                        this.showTips({ text: '开始上传日志...', zIndex: zIndex });
                        // 执行上报
                        return [4 /*yield*/, this.player.offlineLog.reportLogs({
                                downloadOnFailed: true,
                                onlyCurrent: false,
                                reportSource: OFFLINE_LOG_REPORT_TAG,
                            }, function (progress) {
                                _this.showTips({ text: "\u4E0A\u4F20\u4E2D...".concat((progress * 100).toFixed(0), "%"), zIndex: zIndex });
                            })];
                    case 2:
                        // 执行上报
                        _b.sent();
                        this.showTips({ text: '日志上报成功', time: 10, showClose: true, zIndex: zIndex });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        this.showTips({ text: "\u65E5\u5FD7\u4E0A\u62A5\u5931\u8D25: ".concat((err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || err_1), showClose: true, time: -1, zIndex: zIndex });
                        return [3 /*break*/, 5];
                    case 4:
                        this.setUploadBtnState(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    InfoPanelPlugin.prototype.bindHotKeyEvts = function (isBind) {
        var _a = this.config.enableHotKeys, enableHotKeys = _a === void 0 ? true : _a;
        var container = this.player.container;
        var containerBinder = getEventTargetBinder(container, isBind);
        if (!enableHotKeys)
            return;
        // 如果单用 h5 的情况下，container 很有可能没有 tabindex 属性（由控制栏设置）
        // 此时无法在容器上触发 keyboard events
        if (!container.hasAttribute('tabindex')) {
            container.setAttribute('tabindex', '-1');
        }
        containerBinder('keydown', this.onKeyDown);
    };
    InfoPanelPlugin.prototype.showTips = function (options) {
        var tipsPlugin = this.player.plugins.tips;
        if (tipsPlugin) {
            tipsPlugin.show(options);
        }
    };
    /**
     * 生成列表项各种信息，例如每一项的渲染函数，监听器等。
     */
    InfoPanelPlugin.prototype.createInfoItems = function () {
        var _a = this.config, defaultInfo = _a.defaultInfo, _b = _a.disableDefaultKey, disableDefaultKey = _b === void 0 ? [] : _b, enableDebugMode = _a.enableDebugMode;
        if (!defaultInfo) {
            this.infoItems = [];
            return;
        }
        var infoItemMap = [];
        if (!enableDebugMode) {
            infoItemMap.push.apply(infoItemMap, [
                { key: STATS_NAME.VID, label: '视频ID', compactLabel: 'VID', value: '-', hideItemIfEmpty: true },
                { key: STATS_NAME.FLOW_ID, label: '播放流水', compactLabel: 'Flowid', value: '-' },
                { key: STATS_NAME.KERNEL_NAME, label: '播放内核', compactLabel: 'Kernel', value: '-' },
                { key: STATS_NAME.PLAYER_SIZE, label: '显示器信息', compactLabel: 'Res', value: '-' },
                { key: STATS_NAME.FRAME_RATE, label: '帧数', value: '-' },
                { key: STATS_NAME.BUFFER_HEALTH, label: '缓冲健康度', value: '-' },
                { key: STATS_NAME.NET, label: '网络活动', compactLabel: 'net', value: '-' },
                { key: STATS_NAME.VIDEO_SIZE, label: '视频分辨率', value: '-' },
                { key: STATS_NAME.CODEC, label: '编码', compactLabel: 'Codec', value: '-', hideItemIfEmpty: true },
                { key: 'debug', label: 'mystery', compactLabel: 'mystery', value: '-' },
            ]);
        }
        else {
            infoItemMap.push({
                key: DEBUG_MODE_PANEL_ITEM_NAME.resolution,
                label: '有效像素数',
                compactLabel: 'Res',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.framerate,
                label: '帧率',
                compactLabel: 'FPS',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.scanMode,
                label: '扫描模式',
                compactLabel: 'SM',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.colorGamut,
                label: '色域',
                compactLabel: 'cg',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.colorTransfer,
                label: '非线性转换曲线',
                compactLabel: 'tf',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.pixelFormat,
                label: '色度取样',
                compactLabel: 'pf',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.bitDepth,
                label: '量化比特数',
                compactLabel: 'bd',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.samplingStructure,
                label: '取样结构',
                compactLabel: 'ss',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.pixelShape,
                label: '像素形状',
                compactLabel: 'ps',
                value: '',
            }, {
                key: DEBUG_MODE_PANEL_ITEM_NAME.pixelDirection,
                label: '像素排列顺序',
                compactLabel: 'pd',
                value: '',
            });
        }
        // 过滤外部配置的禁用的显示项
        this.infoItems = infoItemMap.filter(function (infoItem) { return !disableDefaultKey.includes(infoItem.key); });
    };
    InfoPanelPlugin.prototype.collectDetailedMediaInfo = function () {
        var _this = this;
        var currentVideoInfo = this.player.currentVideoInfo;
        if (!currentVideoInfo) {
            return;
        }
        var drmConfig = currentVideoInfo.config.drmConfig, videoFrameRate = currentVideoInfo.videoFrameRate, videoHeight = currentVideoInfo.videoHeight, videoWidth = currentVideoInfo.videoWidth, colorSpace = currentVideoInfo.colorSpace, bitDepth = currentVideoInfo.bitDepth, pixelFormat = currentVideoInfo.pixelFormat;
        var isDRM = !!drmConfig;
        if (isDRM) {
            // 如果是drm的，除分辨率外所有信息都无法获取，直接填写默认值
            Object.values(DEBUG_MODE_PANEL_ITEM_NAME).forEach(function (key) {
                if (key === DEBUG_MODE_PANEL_ITEM_NAME.resolution
                    && videoHeight
                    && videoWidth) {
                    _this.setItemTextByKey(DEBUG_MODE_PANEL_ITEM_NAME.resolution, "".concat(videoWidth, "x").concat(videoHeight), false);
                }
                else {
                    _this.setItemTextByKey(key, '[加密视频, 无法获取]', false);
                }
            });
            return;
        }
        // 非DRM视频，每一项做格式转换
        // 特殊逻辑，如果目标是hdr10或者dolby清晰度，且无法获取色域信息，填充pq和bt2020，否则填充bt709
        var currentDefn = this.player.getCommonKv(COMMON_DATA_KEY.currentDefn);
        var colorSpacePrimaries = colorSpace === null || colorSpace === void 0 ? void 0 : colorSpace.primaries;
        var colorSpaceTransfer = colorSpace === null || colorSpace === void 0 ? void 0 : colorSpace.transfer;
        if (!colorSpacePrimaries && !colorSpaceTransfer) {
            if (currentDefn === 'hdr10' || currentDefn === 'dolby') {
                colorSpacePrimaries = TPColorPrimaries.BT2020;
                colorSpaceTransfer = TPTransferCharacteristics.BT2100PQ;
            }
            else {
                colorSpacePrimaries = TPColorPrimaries.BT709;
                colorSpaceTransfer = TPTransferCharacteristics.BT709;
            }
        }
        var valueTransformMap = [
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.resolution,
                value: "".concat(videoWidth, "x").concat(videoHeight),
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.framerate,
                value: videoFrameRate || '',
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.colorGamut,
                value: DEBUG_COLOR_PRIMARIES_PRESENTATION_STRING[colorSpacePrimaries] || '',
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.colorTransfer,
                value: DEBUG_TRANSFER_CHARACTERISTICS_PRESENTATION_STRING[colorSpaceTransfer] || '',
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.pixelFormat,
                value: (pixelFormat === null || pixelFormat === void 0 ? void 0 : pixelFormat.join(':')) || '',
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.bitDepth,
                value: bitDepth ? "".concat(bitDepth, "bit") : '',
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.samplingStructure,
                value: '正交',
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.pixelShape,
                value: '方形',
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.pixelDirection,
                value: '从左到右, 从上到下',
            },
            {
                key: DEBUG_MODE_PANEL_ITEM_NAME.scanMode,
                value: '逐行',
            },
        ];
        valueTransformMap.forEach(function (_a) {
            var key = _a.key, value = _a.value;
            // 字符串类型转换一下
            _this.setItemTextByKey(key, "".concat(value), false);
        });
    };
    /**
     * r:url重试/cgi重试，
     * a：自动播放被拦截，
     * b：缓冲次数，
     * s：state，
     * pg：是否渐进式加载,
     * br: 缓冲区,
     * t: playtime,
     * lc: 直播延迟,
     * sk: seek历史
     */
    InfoPanelPlugin.prototype.collectRegularPlaybackStats = function () {
        var _a, _b, _c, _d, _e, _f;
        var retryBackUrlCount = this.player.getCommonKv(COMMON_DATA_KEY.sessionRetryBackUrlCount) || 0;
        var retryPlayCount = this.player.getCommonKv(COMMON_DATA_KEY.sessionRetryPlayCount) || 0;
        var retryText = (retryBackUrlCount || retryPlayCount)
            ? "r:".concat([retryBackUrlCount, retryPlayCount].join('/'))
            : '';
        var bufferCount = this.player.getCommonKv(COMMON_DATA_KEY.sessionBufferCount) || 0;
        var bufferText = bufferCount ? "b:".concat(bufferCount) : '';
        var bufferRange = this.player.videoBuffered
            .map(function (range) { return "".concat(range.start.toFixed(3), "-").concat(range.end.toFixed(3)); })
            .join(',');
        var bufferRangeText = bufferRange ? "br:".concat(bufferRange) : '';
        var playTimeText = "t:".concat(this.player.playtime.toFixed(2));
        var progressiveModeText = "pg:".concat(+!!((_d = (_c = (_b = (_a = this.player.corePlayer) === null || _a === void 0 ? void 0 : _a.getHls) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.progressive));
        var stateText = "s:".concat(this.stateQueue.join('->'));
        var autoPlayBlockedText = this.autoplayBlockedType ? "a:".concat(this.autoplayBlockedType) : '';
        var latency = (_f = (_e = this.player.currentVideoInfo) === null || _e === void 0 ? void 0 : _e.performance) === null || _f === void 0 ? void 0 : _f.latency;
        var latencyText = latency ? "lc:".concat((latency / 1000).toFixed(2)) : '';
        var encType = this.player.getCommonKv(COMMON_DATA_KEY.drm);
        var encText = encType ? "enc:".concat(encType) : '';
        var seekText = this.seekHistoryList.length > 0 ? "sk:".concat(this.seekHistoryList.map(function (_a) {
            var start = _a.start, end = _a.end;
            return "".concat(start, "-").concat(end);
        }).join(',')) : '';
        var items = [
            retryText,
            bufferText,
            bufferRangeText,
            playTimeText,
            progressiveModeText,
            stateText,
            autoPlayBlockedText,
            latencyText,
            encText,
            seekText,
        ]
            .filter(Boolean)
            .join(' ');
        this.setItemTextByKey('debug', items, false);
    };
    InfoPanelPlugin.prototype.setItemTextByKey = function (key, value, hideItemIfEmpty) {
        if (!key) {
            return;
        }
        var dom = this.getItemDom(key);
        if (!dom) {
            return;
        }
        this.curInfoMap[key] = value;
        if (hideItemIfEmpty) {
            if (!value) {
                dom.el.classList.add(txpHideClass);
                return;
            }
            dom.el.classList.remove(txpHideClass);
        }
        if (dom) {
            dom.value.innerText = value ? value : '-';
        }
    };
    InfoPanelPlugin.prototype.bindInfoItemEvts = function (isBind) {
        var msgBinder = getEventEmitterBinder(this.msg, isBind);
        var playerBinder = getEventEmitterBinder(this.player, isBind);
        msgBinder(H5_EXT_EVENT.STATS_CHANGE, this.onStatsChange);
        // 下面事件全是更新debug项的
        msgBinder(H5_EXT_EVENT.DATASET_UPDATE, this.onDatasetUpdate);
        playerBinder(PLAY_EVENT.STATE_CHANGE, this.onPlayerStatsChange);
        playerBinder(H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS, this.onDebugInfoChange);
        playerBinder(H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED, this.onVideoAutoPlayBlock);
        playerBinder(H5_PLAY_EVENT.VIDEO_TIMEUPDATE, this.onDebugInfoChange);
        playerBinder(H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, this.onAdAutoPlayBlock);
        playerBinder(H5_PLAY_EVENT.VIDEO_SEEKING, this.onVideoSeek);
        playerBinder(H5_PLAY_EVENT.VIDEO_SEEKED, this.onVideoSeek);
        playerBinder(H5_PLAY_EVENT.PLAY_SESSION_END, this.onSessionEnd);
    };
    InfoPanelPlugin.prototype.updateInfoItems = function () {
        var _this = this;
        var _a, _b;
        var infos = (_b = (_a = this.player).getStats) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!infos) {
            return;
        }
        this.infoItems.forEach(function (infoItem) {
            _this.setItemTextByKey(infoItem.key, infos[infoItem.key], infoItem.hideItemIfEmpty);
        });
        this.onDebugInfoChange();
    };
    /**
     * 移动端 / 小尺寸播放器，呼出信息面板时，信息面板全屏展示
     */
    InfoPanelPlugin.prototype.isMiniPanel = function () {
        var _a = this.config.smallSizeThreshold, smallSizeThreshold = _a === void 0 ? 400 : _a;
        var clientWidth = this.player.container.clientWidth;
        return clientWidth < smallSizeThreshold;
    };
    InfoPanelPlugin.pluginName = InfoPanelPluginName;
    /** 插件内部广播的事件 */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    InfoPanelPlugin.Events = InfoPanelEvents;
    return InfoPanelPlugin;
}(Plugin));

H5Player.registerPlugin(InfoPanelPlugin.pluginName, InfoPanelPlugin);

export { InfoPanelPlugin };
